(function() {
  define('tlh/simpleModal',['angular'], function() {
    'use strict';
    return angular.module('tlhComponentsSimpleModal', ['ngSanitize', 'ngAnimate', 'ui.bootstrap']).component('tlhSimpleModal', {
      template: '<ng-transclude ng-click="$ctrl.openModal()"></ng-transclude>',
      transclude: true,
      bindings: {
        title: '@',
        body: '@'
      },
      controller: [
        '$uibModal', function($uibModal) {
          var vm;
          vm = this;
          vm.openModal = function() {
            return $uibModal.open({
              templateUrl: '/assets/javascripts/tlh/simpleModal.html',
              controllerAs: '$ctrl',
              bindToController: true,
              resolve: {
                data: {
                  title: vm.title,
                  body: vm.body
                }
              },
              controller: [
                '$uibModalInstance', 'data', function($uibModalInstance, data) {
                  var mvm;
                  mvm = this;
                  mvm.$onInit = function() {
                    mvm.title = data.title;
                    return mvm.body = data.body;
                  };
                  mvm.close = function() {
                    return $uibModalInstance.dismiss();
                  };
                }
              ]
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=simpleModal.js.map
;
